module.exports = __webpack_public_path__ + "static/img/10长城宽带@2x.73e854d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/partners/10长城宽带@2x.png
// module id = SbkE
// module chunks = 1